export default __webpack_public_path__ + "static/media/prize.min.b38fb679.png";